/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Catalog_GenerateInputs */

const cs_templates_use_catalog_generate = /** @type {(inputs: Templates_Use_Catalog_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generovat katalog`)
};

const en_templates_use_catalog_generate = /** @type {(inputs: Templates_Use_Catalog_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate catalog`)
};

/**
* | output |
* | --- |
* | "Generate catalog" |
*
* @param {Templates_Use_Catalog_GenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_catalog_generate = /** @type {((inputs?: Templates_Use_Catalog_GenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Catalog_GenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_catalog_generate(inputs)
	return cs_templates_use_catalog_generate(inputs)
});